import React from "react";
import "../shared/index.css";

export function Step1() {
  return (
    <div className="onboarding-steps">
      <h1 className="onboarding-step--title">Step 1</h1>
      <p className="onboarding-step--description">
        We encourage our Seller community to only send items that are in
        good condition. Good items are free from stains, wear and tear, major
        piling/lint, fading and damages. Also, we encourage items that are
        suitable for the season - winter/fall collection during winter and
        summer/spring collection during summer.
      </p>
      <div className="onboarding-facts">
        <h4>Facts</h4>
        <p>
          We provide our sellers with recommended selling prices that factor in the quality of the items,
          the current trend, seasonal relevance, and what similar items on our platform are selling for.
          Only 60% of the items are selected on average.
        </p>
      </div>
    </div>
  );
}
